import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

function AppFormSection({ title, children, sx }) {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        backgroundColor: "action.hover",
        p: 2,
        minWidth: 0,
        ...sx,
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

AppFormSection.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default AppFormSection;
